import { createElementObject, createTileLayerComponent, updateGridLayer, withPane } from '@react-leaflet/core';
export const LeafletTileLayer = createTileLayerComponent(function createTileLayer({ url , ...options }, context) {
    const layer = new window.L.tileLayer(url, withPane(options, context));
    return createElementObject(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    updateGridLayer(layer, props, prevProps);
    const { url  } = props;
    if (url != null && url !== prevProps.url) {
        layer.setUrl(url);
    }
});
